var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "animate-css",
          rawName: "v-animate-css",
          value: { classes: "fadeInDown", delay: 0, duration: 300 },
          expression: "{ classes: 'fadeInDown', delay: 0, duration: 300 }",
        },
      ],
      staticClass: "automation-webhook-details",
    },
    [
      _c("section", [
        _c("span", { staticClass: "title" }, [
          _vm._v("Catch All Webhooks from this URL"),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "url" },
          [
            _c("a-input", {
              attrs: { value: _vm.getWebhookURL(), disabled: "" },
            }),
            _vm._v(" "),
            _c("SupsisButton", { on: { click: _vm.copy } }, [_vm._v("Copy")]),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("a-divider"),
      _vm._v(" "),
      _c(
        "section",
        [
          _c("span", { staticClass: "title" }, [
            _vm._v(
              "Webhook Data Example Preview (will show after you sent request)"
            ),
          ]),
          _vm._v(" "),
          _c("vue-json-pretty", { attrs: { data: _vm.getWebhookData() } }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }